import { createSlice } from "@reduxjs/toolkit";

const initialState = {}

const reset_store = createSlice({
    name: "reset_store",
    initialState: initialState,
    reducers: {
        handlerResetStore(state, action){
            console.log(action);
            state=action.payload;
        }
    }
})

export default reset_store.reducer;

export const {handlerResetStore} = reset_store.actions;